import { batch } from 'react-redux';
import { setIsSettingsLoading, setUserSettings } from '.';
import { getUserSettings, updateUserSettings } from '../../../../api/users';
import type { PreferredLanguage } from '../../../../api/users';
import { fetchTenant } from '../../../../containers/Organizations/OrganizationsSlice/actionCreators';
import { ELanguages } from '../../../../i18n';
import type { AppThunk } from '../../../../store';
import { setItem } from '../../../../utils/storage';

const ELANGAUGE_TO_PREFERRED_LANGUAGE_MAPPER: Record<ELanguages, PreferredLanguage | null> = {
  [ELanguages.se]: 'sv',
  [ELanguages.fi]: 'fi',
  [ELanguages.pt]: 'pt',
  [ELanguages.nl]: 'nl',
  [ELanguages.es]: 'es',
  [ELanguages.en]: 'en',
  [ELanguages['en-TT']]: 'en',
} as const;

export const fetchUserSettings =
  (userId: number): AppThunk =>
  async (dispatch, getState) => {
    try {
      dispatch(setIsSettingsLoading(true));

      let tenant = getState().organizations.tenant;
      if (!tenant) {
        await dispatch(fetchTenant());
        tenant = getState().organizations.tenant;
        if (!tenant) {
          throw new Error('Missing tenant when fetching user settings');
        }
      }

      const res = await getUserSettings({ userId, tenantId: tenant.id });
      if (res.error) {
        throw new Error('Error when retrieving user settings');
      }
      batch(() => {
        dispatch(setUserSettings(res.data.data));
        dispatch(setIsSettingsLoading(false));
      });
    } catch (error) {
      dispatch(setIsSettingsLoading(false));
      console.log('error log ', error);
    }
  };

export const setLanguage =
  (userId: number, language: ELanguages, onSuccess?: () => void): AppThunk =>
  async (dispatch, getState) => {
    try {
      const preferredLanguage = ELANGAUGE_TO_PREFERRED_LANGUAGE_MAPPER[language] ?? null;

      let tenant = getState().organizations.tenant;
      if (!tenant) {
        await dispatch(fetchTenant());
        tenant = getState().organizations.tenant;
        if (!tenant) {
          throw new Error('Missing tenant when setting language');
        }
      }

      const res = await updateUserSettings({
        userId,
        tenantId: tenant.id,
        body: { preferredLanguage },
      });
      if (res.error) {
        throw new Error('Unable to update preferred language');
      }
      setItem('language', language);
      onSuccess?.();
    } catch (error) {
      console.log('error log ', error);
    }
  };
